import AccountsList from './AccountsList';
import AccountsShow from './AccountsShow';

export default {
  list: AccountsList,
  show: AccountsShow,
};
